import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
export var Event = function Event(type, data) {
  _classCallCheck(this, Event);

  _defineProperty(this, "cancelBubble", void 0);

  _defineProperty(this, "cancelable", void 0);

  _defineProperty(this, "target", void 0);

  _defineProperty(this, "currentTarget", void 0);

  _defineProperty(this, "preventDefault", void 0);

  _defineProperty(this, "stopPropagation", void 0);

  _defineProperty(this, "type", void 0);

  _defineProperty(this, "timeStamp", void 0);

  this.cancelBubble = false;
  this.cancelable = false;
  this.target = null;
  this.currentTarget = null;

  this.preventDefault = function () {};

  this.stopPropagation = function () {};

  this.type = type;
  this.timeStamp = Date.now();
};
//# sourceMappingURL=Event.js.map